import { Middleware } from '@reduxjs/toolkit';

import {
  continueProcessing,
  initiatePaymentSnapshot,
  processPayment,
  processPaymentFailure,
  processPaymentSuccess,
  registerPayment,
  requestSdkProcessor,
  selectPaymentMethod,
  selectProcessingResult,
} from '@cashier/cashier-data-access';
import { FormPayload, RedirectContainers } from '@cashier/cashier-model';
import { ProviderWindowService } from '@cashier/cashier-shared';

import {
  extractAmountValue,
  PaymentAttributesMapper,
} from '../services/common';

export const cashierHostedFieldBridgeMiddleware: Middleware =
  (store) => (next) => (action) => {
    const result = next(action);

    if (action.type === requestSdkProcessor.toString()) {
      const processingResult = selectProcessingResult(store.getState());
      const { response, status, error } = action.payload;

      if (status) {
        const paymentMethod = selectPaymentMethod(store.getState());

        const isRedirect =
          response?.type === 'redirect' &&
          response?.redirectUrl &&
          RedirectContainers.NEW_TAB === paymentMethod.redirectContainer;

        if (isRedirect) {
          ProviderWindowService.redirect(
            response.redirectUrl,
            paymentMethod.redirectContainer === RedirectContainers.NEW_TAB,
          );

          return;
        }

        store.dispatch(processPaymentSuccess(processingResult));
      } else {
        store.dispatch(
          processPaymentFailure({
            message: error,
            attributeErrorBag: null,
            errorDetails: { description: error },
            transactionId: error?.transactionId,
            context: null,
          }),
        );
      }
    }

    if (action.type === continueProcessing.toString()) {
      const {
        paymentForm: { formSchema, formPayload },
        paymentMethod: {
          paymentMethod: { vendor, id: paymentMethodId, referenceId, source },
          registrationRequired,
        },
        cashierConfiguration: {
          merchantId,
          userId,
          sessionId,
          paymentType,
          language,
          host,
        },
        customerInformation: { bonusCode },
      } = store.getState();

      const commonFormPayload = PaymentAttributesMapper.fromPayload(
        formPayload as FormPayload,
      );

      const totalPayload = {
        ...commonFormPayload,
        ...action.payload,
      };

      const callbackParameterBag = {
        userId,
        sessionId,
        merchantId,
        language,
        host,
        paymentMethodId,
      };

      const finalAmount = extractAmountValue(formSchema, formPayload);

      store.dispatch(initiatePaymentSnapshot(finalAmount || ''));

      if (registrationRequired) {
        store.dispatch(
          registerPayment({
            referenceId,
            type: paymentType,
            walletId: userId,
            sessionId,
            merchantId,
            methodId: paymentMethodId,
            attributes: {
              ...totalPayload,
              bonusCode,
            },
          }),
        );
      } else {
        store.dispatch(
          processPayment({
            paymentMethodId,
            vendor,
            merchantId,
            paymentType,
            userId,
            sessionId,
            paymentAttributes: {
              ...totalPayload,
              bonusCode,
            },
            callbackParameterBag,
            referenceId,
            source,
          }),
        );
      }
    }
    return result;
  };
